import React, { useRef } from 'react';
import { Button as BButton, ButtonProps as BButtonProps, Spinner, SpinnerProps } from 'react-bootstrap';
import './Button.css';

type buttonVariant = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' |
  'light' | 'link' | 'outline-primary' | 'outline-secondary' | 'outline-success' | 'outline-danger' | 'outline-warning' | 'outline-info' | 'outline-dark' | 'outline-light'


const variantsToDisplay = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  LIGHT: 'light',
  LINK: 'link',
  OUTLINE_PRIMARY: 'outline-primary',
  OUTLINE_SECONDARY: 'outline-secondary',
  OUTLINE_LIGHT: 'outline-light',
};

const buttonSize = {
  Small: 'sm',
  Default: '',
  Large: 'lg',
};
type ButtonProps = BButtonProps & {
  loading?: boolean;
  loadingText?: string;
  children?: React.ReactNode;
  spinnerProps?: SpinnerProps;
  active?: boolean;
  disabled?: boolean;
  onClick?: (e?: any) => void;
  size?: 'sm' | 'lg';
  variant?: buttonVariant;
  className?: string;
  /** Clicks within this many ms of the last accepted click are dropped. 0 disables. */
  debounceMs?: number;
}

const Button = ({ loading, loadingText = 'Loading', children, spinnerProps = {size: 'sm', animation: 'border'}, debounceMs = 250, onClick, ...props }: ButtonProps) => {
  const lastClick = useRef(0);

  // Leading-edge: the first click fires immediately, repeats inside the window are swallowed
  // (including the native default, so type="submit" can't double-submit a form).
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const now = Date.now();
    if (debounceMs > 0 && now - lastClick.current < debounceMs) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    lastClick.current = now;
    onClick?.(e);
  };

  return (
    <BButton {...props} onClick={handleClick}>
      {loading ? (
        <span className="btn-loading-container">
          <Spinner {...spinnerProps as any} />
          <span className="btn-loading-text">{loadingText}</span>
        </span>
      ) : (
        children
      )}
    </BButton>
  );
};


export default Button;
export { Button, buttonSize, variantsToDisplay };
